import { IAttrValue } from "@multiweb/types/contracts";
import { AttrValueReader } from "OW.Remoting/Remoting/AttrValueReader";
import { EventHelper } from "UI/UI.BaseControls/Helpers/EventHelper";
import { ElementUtils } from "UI/UI.ElementarControls/Helpers/ElementUtils";
import { IHTMLElementWithControl } from "UI/UI/UI/Controls/ControlInterfaces";
import { LinkEdit } from "UI/UI/UI/Controls/LinkEdit";
import { IValidatable } from "../../../../../../UI.BaseControls/ControlInterfaces";
import { Column } from "../../../../../../UI.Controls/DataGridSubcontrols/Columns/Column";
import { EditItemTemplate } from "../../../../../../UI.Controls/DataGridSubcontrols/Templates/EditItemTemplate";

export class LinkEditTemplate extends EditItemTemplate {
    public override updateData(dataSet: IAttrValue[], item: HTMLElement): void {
        const data = AttrValueReader.read(this._getDataFromSet(dataSet));
        if (data && item instanceof IHTMLElementWithControl && item.tscControl instanceof LinkEdit)
            item.tscControl.controlValue = data;
    }

    protected override _createEditElement(column: Column, _dataSet: IAttrValue[], parentItem: HTMLElement): { element: HTMLElement; validatableControl: IValidatable } {
        const editableControl = document.createElement("div");
        editableControl.setAttribute("data-attrname", this.parentColumn.attrName);
        const linkEdit = new LinkEdit({ element: editableControl, originalRightsDefinition: this.parentColumn.originalRightsDefinition });

        linkEdit.valueChanged.add(() => {
            ElementUtils.callEvent(parentItem, "valuechanged", { value: linkEdit.controlValue, column: column });
        });
        //Následující event listenery převzaty z baseControls/EditableControl (LinkEdit dědí z controls/EditableControl). Bez nich click odchyti datagrid a editace se může chovat nestandardně.
        //Pokud se najde další editační seznamová komponenta, které tohle bude chybět, tak tu logiku vyextrahovat do samostatné funkce nebo dekorátoru.
        linkEdit.element.addEventListener("keydown", (e: KeyboardEvent) => {
            if (e.key !== "Escape") //Escape
                e.stopPropagation();
        });
        linkEdit.element.addEventListener("keyup", (e: KeyboardEvent) => {
            EventHelper.stopPropagation(e);
        });
        linkEdit.element.addEventListener("keypress", (e: KeyboardEvent) => {
            e.stopPropagation();
        });
        return { element: linkEdit.element, validatableControl: linkEdit };
    }
}
